import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import VueGtag from "vue-gtag";
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import appConfig from "./config/app.config";
import platformConfig from "@/config/platform.config";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);

const logo = document.getElementById("splash-logo") as HTMLImageElement;
const faviconLink = document.querySelector(
  "link[rel~='icon']"
) as HTMLAnchorElement;

if (logo && process.env.VUE_APP_PLATFORM) {
  const logos = {
    gabon: "/media/logos/gabon-logo.svg",
  };
  logo.src =
    logos[process.env.VUE_APP_PLATFORM] || "/media/logos/prosper-logo-fit.svg";
}

if (faviconLink) {
  const favicons = {
    gabon: "/media/platforms/gabon/gabon-ico.png",
  };
  faviconLink.href = favicons[process.env.VUE_APP_PLATFORM] || "/favicon.ico";
}

app.use(
  VueGtag,
  {
    config: { id: platformConfig.trackingGA || appConfig.trackingGA },
  },
  router
);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
